// External libraries
import React from 'react';
// @ts-expect-error untyped-import
import { LoadingElement } from '@checkout/react-components';

// Internal modules
// @ts-expect-error untyped-import
import { lazyLoader } from '@/lib';
import { SepaMandate } from './SepaMandate';
import { RightOfWithdrawal } from './RightOfWithdrawal';
import { PrivacyStatement } from './PrivacyStatement';
import { ThirdPartyDataConsentCheckbox } from './ThirdPartyDataConsent/ThirdPartyDataConsent';
import { UniqueInformationProcessingCheckbox } from './UniqueInformationProcessing';

const LazySepaMandate = lazyLoader({
  loader: () => import('./SepaMandate'),
  loading: () => <LoadingElement />,
  name: 'sepa_mandate',
  // @ts-expect-error instead of using any to define props
  render(loaded, props) {
    return <SepaMandate {...props} />;
  },
});

const LazyRightOfWithdrawal = lazyLoader({
  loader: () => import('./RightOfWithdrawal'),
  loading: () => <LoadingElement />,
  name: 'right_of_withdraw',
  // @ts-expect-error instead of using any to define props
  render(_, props) {
    return <RightOfWithdrawal {...props} />;
  },
});

const LazyPrivacyStatement = lazyLoader({
  loader: () => import('./PrivacyStatement'),
  loading: () => <LoadingElement />,
  name: 'privacy_statement',
  // @ts-expect-error instead of using any to define props
  render(loaded, props) {
    return <PrivacyStatement {...props} />;
  },
});

const LazyThirdPartyDataConsent = lazyLoader({
  loader: () => import('./ThirdPartyDataConsent'),
  loading: () => <LoadingElement />,
  name: 'third_party_data_consent',
  // @ts-expect-error instead of using any to define props
  render(loaded, props) {
    return <ThirdPartyDataConsentCheckbox {...props} />;
  },
});

const LazyUniqueInformationProcessing = lazyLoader({
  loader: () => import('./UniqueInformationProcessing'),
  loading: () => <LoadingElement />,
  name: 'third_party_data_consent',
  // @ts-expect-error instead of using any to define props
  render(loaded, props) {
    return <UniqueInformationProcessingCheckbox {...props} />;
  },
});

export {
  LazyRightOfWithdrawal,
  LazySepaMandate,
  LazyPrivacyStatement,
  LazyThirdPartyDataConsent,
  LazyUniqueInformationProcessing,
};
